<template>
  <span>
    <a
      v-if="linkValido"
      :href="enderecoCompleto"
      rel="noopener noreferrer"
      target="_blank"
    >{{ endereco }}</a>     
    <span v-else>
      {{ endereco }}
    </span>
  </span>
</template>

<script>
export default {
  name: "LinkEndereco",
  props: {
    endereco: {
      type: String,
      default: ''
    }
  },
  computed: {
    linkValido() {
      if (this.endereco?.substring(0,5) == "https" || this.endereco?.substring(0,3) == "www") {
        return true
      }
      return false
    },
    enderecoCompleto() {
      if(this.endereco?.substring(0,3) == "www") {
        return "https://" + this.endereco
      }
      return this.endereco
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  margin-left: 0.5rem;
}
</style>